<script>
export default {
    name: 'IlluPedagogieDynamique',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-pedagogie-dynamique"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M27.084 28.5c-4.31 0-8.294 1.398-11.522 3.767A19.54 19.54 0 008.525 42a19.54 19.54 0 007.038 9.734A19.412 19.412 0 0027.084 55.5c4.31 0 8.294-1.398 11.522-3.767A19.54 19.54 0 0045.644 42a19.54 19.54 0 00-7.038-9.734A19.412 19.412 0 0027.084 28.5zm0-20c-2.07 0-3.946.84-5.303 2.197A7.477 7.477 0 0019.584 16c0 2.071.84 3.946 2.197 5.303a7.477 7.477 0 005.303 2.197c2.071 0 3.946-.84 5.304-2.197A7.477 7.477 0 0034.584 16c0-2.071-.84-3.946-2.196-5.303A7.477 7.477 0 0027.084 8.5z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <path
                d="M37.5 13H51c2.21 0 4 2.29 4 4.5V33a4 4 0 01-4 4h-3"
                :stroke="secondaryColor" class="secondary-color"
                stroke-linecap="round"
            />
            <path
                :fill="primaryColor" class="primary-color"
                d="M51.02 17.639l-.005 7.995h-2v-4.656L39.5 30.5 38 29l9.527-9.363-4.507.002v-2l7.995-.005z"
            />
        </g>
    </svg>
</template>
